import RoomSpiderwebEdit from './RoomSpiderwebEdit.vue';
import RoomSpiderweb from './RoomSpiderweb.vue';
export { RoomSpiderwebEdit };
export default RoomSpiderweb;
